const pt = {
  
  //Geral
  saibaMais: "Saiba Mais",

  //Header
  home: "Home",
  solucoes: "Soluções",
  clientes: "Clientes",
  sobreNos: "Sobre nós",
  contato: "Contato",
  politicaPrivacidade: "Política de Privacidade",

  //Página de Login
  login: "Login",
  esqueceuSenha: "Esqueceu a senha?",


  //Fooder
  menu: 'Menu',


  //Clientes
  senha: "Senha",

  //Soluções
  nossasSolucoes: "Nossas Solucões",
  polofacil: "PoloFácil",
  polofacil_p1: "Sistema de Gerenciamento de Polos",

  phponto: "PHPonto",
  phponto_p1: "Sistema de Gerenciamento de Jornada de Trabalho",

  compact: "Compact",
  compact_p1: "Software de Gestão e Automação Comercial",

  mensageiro: "Mensageiro",
  mensageiro_p1: "Ferramenta De Vendas, Envio De Whatsapp, E-mails E Sms",

  gcert: "Gcert",
  gcert_p1: "Software Gerador de Certificados",


  //Contato
  entrarEmContato:"Entrar em contato",
  primeiroNome: "Primeiro Nome",
  ultimoNome: "Último nome",
  seuEmail: "Seu email",
  seuTelefone: "Seu número de telefone",
  digiteSuaMensagem:"Digite aqui sua mensagem",
  enviarMensagem: "Enviar Mensagem",
  contateNos: "Contate-Nos",

  //Contato - FaleF4cil
  nomeCompleto: "Nome",
  suaCidade: 'Cidade',
  enviar: "Enviar",
  obrigadoContato:"Obrigado por seu contato",
  preencha:"Preencha corretamente e envie os dados para que entremos em contato com você",
  emailEnviado:"Email enviado",
  parabensEmailEnviado:"Parabéns, seu email foi enviado com sucesso!",
  ou: "Ou",

  //Features
  polofacilWeb: "PoloFácil Web",
  polofacilWeb_f_p1: "Ganhe tempo e matrículas gerenciando de forma rápida, simples e segura, o seu Polo EAD utilizando as ferramentas do PoloFácil..",
  polofacilWeb_f_p2: "Agende provas, confira apostilas disponiveis, tenha acesso a centenas de provas simuladas para estudar e muito mais. Tudo de forma rápida, simples e segura.",

  meuPhponto:"MEU PHPONTO",
  bomEfacil: "PORQUE É BOM E FÁCIL",
  meuPhponto_f_p1: "Desenvolvido para atender na íntegra a Portaria 1510 do Ministério do Trabalho e Emprego, o PHPONTO oferece ao gestor de Recursos Humanos uma excelente ferramenta de gerenciamento do Ponto.",
  meuPhponto_f_p2:" Por causa da sua interface (telas) limpa e compreensível, o operador aprende rapidamente todas as funções do software, reduzindo bastante o tempo de assimilação e a necessidade de novos treinamentos. Isto significa economia de tempo e dinheiro.",

  //iq-about
  sobreAF4cil: "Sobre a F4CIL",
  sobreAF4cil_p1:"A F4CIL nasceu com a finalidade de facilitar a informática para nossos clientes. Com mais de 20 anos de experiência dos seus fundadores, a F4CIL vem se aprimorando em oferecer serviços nas diversas área da tecnologia da informação.",
  sobreAF4cil_p2:"Dispomos de profissionais altamente gabaritados com vasto conhecimento e disponibilidade para que sua empresa funcione sem complicação.",

  // Sobre a F4CIL
  sobreAf4cil_sub_title: "A tecnologia pode ser simples",
  nossoCompromisso: "Nosso compromisso",
  sobre_p1: "A F4CIL nasceu com o objetivo de facilitar a tecnologia da informação para nossos clientes.",
  sobre_p2: "Com mais de 20 anos de experiência na oferta de serviços em diversas áreas da tecnologia da informação, contamos com profissionais altamente qualificados, com vasto conhecimento e disponibilidade para fazer sua empresa funcionar sem complicações.",

  Nosso_compromisso: "Nosso compromisso",
  Nosso_compromisso_p1: "Nosso compromisso não é apenas com a qualidade. Isso faz parte do nosso dia a dia para que nunca esqueçamos que a satisfação de quem usa nossos serviços é nosso maior objetivo.",
  Nosso_compromisso_p2: "Os sistemas que desenvolvemos são pensados sempre pela perspectiva de quem vai utilizar. Nossos programadores sabem que desta maneira, receberemos os melhores elogios e indicações.",

  //Nossa História

  Nossa_História: "Nossa História",
  Nossa_História_Inicio: "História de Experiência e Credibilidade",
  Nossa_História_Inicio_p1: "Fundada em Janeiro de 2008, acumulamos, junto com a experiência de nossos fundadores, mais de 30 anos de experiência  no mercado de Desenvolvimento de Softwares, Aplicativos e Soluções em TI, sempre focados em simplificar a vida de nossos clientes.",
  Nossa_História_Inicio_p2:"A F4CIL é registrada junto a SEFAZ-PE com empresa Interventora credenciada. Com este registro estávamos habilitados a: Vender, Realizar A Inicialização de Uso, Intervenções e Cessação e uso em ECFs (Emissor de Cupons Fiscais). Conseguimos também neste ano a Homologação para trabalhar com Softwares de Automação.",
  
  Nossa_História_2009: "Foi um marco na história da F4CIL. O Governo lançou a Portaria 1510 do Ministério do Trabalho e Emprego, que regulamentou o uso do Ponto Eletrônico nas empresas. A F4CIL, que já possuia experiência como revenda e suporte de sistemas de ponto, partiu para o desenvolvimento de uma solução própria para atender a P1510 na íntegra.",
  Nossa_História_2009_p1: "O desafio foi criar uma ferramenta que, ao contrário dos sitemas conhecidos, tivesse como principal característica a facilidade de uso, sem abrir mão da confiabilidade e eficiência. Surgiu assim o PHPonto.",
  
  Nossa_História_2010: "Buscando  ampliar a gama de produtos e serviços, nos credenciamos junto ao INMETRO-PE para ofertar os serviços de calibração e manutenção em balanças comerciais.",
  Nossa_História_2010_p1:"Além disso passamos a ofertar também as soluções TEF (Transferência Eletrônica de Fundos)  que passou a ser obrigatória conjuntamento com as ECFs",
  
  Nossa_História_2011: "Mais um credenciamento, passamos por um longo processo de adequação e capacitação para passarmos a oferecer à nossos clientes a opção de compra do Certificado Digital, importante para habilitação e emissão das NF-e (Notas Fiscais Eletrônicas)",
  
  Nossa_História_2012:"Começa o desenvolvimento do nosso software focado para MEI (Micro Empreendedor Individual) o EasyNfe. Voltado para emissão de NF-e, de forma simplificada visando atender a este público específico.",
  
  Nossa_História_2013:"O Software ONE é implantado em dois importantes portos (Exportação de Cereais e de Veículos) na Bahia, para controlar o acesso de pessoas e veículos pesados.",
 
  Nossa_História_2014:"Credenciamento para venda e manutenção de Equipamentos de Ponto Eletrônico para atender a demanda em Pernambuco, principalmente nas unidades de saúde municipais",
 
  Nossa_História_2015:"Nos consolidamos no mercado de Software de Tratamento de ponto, fechando contratos com diversas UPAs, e Secretarias Municipais de Saúde.",
  Nossa_História_2015_p1:"Nosso Software atende todos os ramos de atividades, porém a partir de 2015, criamos soluções que facilitam a implementação em unidades de saúde.",
 
  Nossa_História_2016:"Iniciamos nossas operações também com uma base na cidade do Rio de Janeiro sob a diretoria do experiente José Marcelino, trazendo mais confiabilidade e profissionalismo a empresa.",
  
  Nossa_História_2017:"Nosso Software PoloFácil, começa a ser usado e indicado para diversos Polos da Rede UNIP - Universidade Paulista, trazendo uma grande inovação para os polos e diferencial competitivo.",
  
  Nossa_História_2018:"Uma equipe da F4CIL vai até Tabatinga - AM, para implantar o PoloFacil no Polo da UNIP - Tabatinga - AM. Consolidando nossa liderança  em softwares para Gerenciamento de Polos EAD. Iniciamos também o projeto topvix.com.br com integração com WhatsApp  com envio automático de mensgens",
  
  Nossa_História_2019:"Neste ano iniciamos dois grandes projetos, o sistema de Agendamento de Provas on-line para os Polos clientes do PoloFacil, e o PersonaTest - Instrumento de mapeamento de perfil comportamental através da identificação do TIPO PSICOLÓGICO.",
  Nossa_História_2019_p1:"Anda em 2019 iniciamos o projeto Compacto - Automação Comercial. A ideia é simplificar a vida de pequenos e médios comerciantes com o uso do sistema compra/venda de mercadorias",
  
  Nossa_História_2020:"Apesar da pandemia do COVID-19 a F4CIL tem atuado em diversos projetos este ano. Desenvolvemos a versão Android do Meu PHPonto para que os funcionários das empresas clientes que estivessem trabalhando em home-office pudessem realizar a solicitação de marcação do ponto sem prejuízo das horas trabalhadas;",
  Nossa_História_2020_p1:"Lançamos o portal phponto.com.br para facilitar o gerenciamento do RH; Lançamos o Mensageiro - Software de envio de mensagens via WhatsApp, SMS  e-mails automáticos e o GeCert um gerador de certificados com envio de e-mail, ótimo para cursos, treinamentos, palestrantes, escolas etc. Lançamento do Persona Test.",
  
  //Nosso Time 
  Nosso_Time:"Nosso Time",
  Nosso_Time_p1:"Veja quem faz o seu projeto acontecer.",

  //Nossos Clientes
  Nossos_Clientes:"Nossos Clientes",
  Nossos_Clientes_p1: "Alguns de nossos Satisfeitos Clientes",
  Nossos_Clientes_MAPROTEC:"Somos clientes da F4CIL e recomendamos esta empresa pela seriedade, pelo pronto atendimento, precisão e pontualidade nos prazos acordados, sempre com respostas rápidas e com soluções tecnológicas agregando valor ao nosso negócio. Márcio Damasceno - MAPROTEC ENGENHARIA.",
  Nossos_Clientes_Cruzeiro:"A F4CIL facilita nossa rotina diária com suas soluções, além de automatizar operações que antes demandavam tempo. O PHPonto por exempo, sua principal característica esta na facilidade de uso e na rápida curva de aprendizagem . Totalmente intuitivo e simples. Adorei!!!",
  Nossos_Clientes_Prefeitura_terra:"Soluções sensacionais, simples, facil de usar, é o que a F4CIL Tecnlogia promove. a equipe de suporte é maravilhosa e nos atende nde maneira rápida e muito segura. O PHPonto, foi o único software que atendeu 100% de acordo com as exigências do Ministério do Trabalho",
  Nossos_Clientes_Prefeitura_Serrita:"É a certeza de puder contar com o que tem de melhor no mercado. Vai além de atender as necessidades do cliente. É amiga e parceira! Todas as demandas solicitadas foram atendidas em tempo. Suporte técnico excelente, sempre pronto a atender. Muito obrigado pela parceria e sucesso sempre!",
  //PoloFácil
  controleTutoria: "Controle de Tutoria",
  importacaoDados : "Importação de Dados on-line",
  controleFinazeiro: "Controle Finazeiro Completo",

  Contas_a_Parar:"Contas a Parar",
  Contas_a_Receber:"Contas a Receber",
  Controle_de_Pagamentos_do_alunos:"Controle de Pagamentos do alunos",
  Envio_de_mensagens:"Envio de mensagens (WhatsApp, Email, SMS)",
  Controle_de_Leads:"Controle de Leads / Candidatos",
  Funil_de_vendas:"Funil de vendas",
  Acompanhamento_de_taxa_de_evasão:"Acompanhamento de taxa de evasão",
  Controle_de_Rematricula:"Controle de Rematricula",
  Cadastro_de_colaboradores:"Cadastro de colaboradores com controle de férias, pagamentos de salários etc",
  Controle_e_acompanhamento:"Controle e acompanhamento de assiduidade ao AVA",
  Diversos_relatórios:"Diversos relatórios administrativos",
  Importando_os_contatos:"Importando os contatos do seu Smartphone você elimina a tarefa chata de ficar selecionando os destinatários e enviando aos poucos.",
  Faça:"Faça como as grandes empresas e apareça para um grande número de pessoas em qualquer lugar.",
  Envio:"Envio de: Imagens, Videos, Aquivos e Áudios",

  //PHPONTO
  Desenvolvido:"Desenvolvido para atender na íntegra a Portaria 1510 do Ministério do Trabalho e Emprego, o PHPONTO oferece ao gestor de Recursos Humanos uma excelente ferramenta de gerenciamento do Ponto.",
  Por_causa_da_sua_interface:"Por causa da sua interface (telas) limpa e compreensível, o operador aprende rapidamente todas as funções do software, reduzindo bastante o tempo de assimilação e a necessidade de novos treinamentos. Isto significa economia de tempo e dinheiro.",
 
 //MENSAGEIRO
 Para_vender_bastante:"Para vender bastante você precisa fazer contato com um número enorme de pessoas e empresas e nem sempre o tempo é favorável. Pensando nisso, desenvolvemos um sistema para auxiliar profissionais autônomos e empresas de qualquer tamanho nesta tarefa.",
 Enquanto_você:"Enquanto você faz outras atividades, o Mensageiro entrega sua propaganda ou mensagem a milhares de pessoas. Você pode enviar diversos anexos como, documentos do Word, planilhas, PDF, imagens, fotos, contatos e tudo que o canal escolhido permitir.", 
 Faça_como_as_grandes_empresas:"Faça como as grandes empresas e apareça para um grande número de pessoas em qualquer lugar.",
 Envio_de: "Envio de: Imagens, Videos, Aquivos e Áudios",

 //GECERT
 Escolas:"Escolas",
 Polos_EAD:"Polos EAD",
 Cursos:"Cursos",
 Treinamentos:"Treinamentos",
 Funcionamento_bastante_simples:"Funcionamento bastante simples, basta selecionar uma imagem correspondente ao modelo de certificado e importar um arquivo com uma listagem de nomes",
 Ideal:"Ideal para quem precisa imprimir vários Certificados de uma vez.",
 
 //Compacto

 Funciona_em_rede:"1. Funciona em rede.",
 Cadastro_de_Usuários:"2. Cadastro de Usuários e controle de acesso",
 Cadastro_de_Pessoas:"3.Cadastro de Pessoas (Clientes, Funcionários, Fornecedores)",
 Cadastro_de_Transportadoras:"4.Cadastro de Transportadoras",
 Cadastro_de_Vendedores:"5.Cadastro de Vendedores",
 Cadastro_de_Centro_de_Custo:"6.Cadastro de Centro de Custo, Forma de Pagamento e Conta",

 Contas_à_Pagar: "7.Contas à Pagar",
 Contas_à_Receber:"8.Contas à Receber",
 Livro_Caixa:"9.Livro Caixa",

 Carnê:"13.Carnê",
 Cadastro_de_Produtos:"14.Cadastro de Produtos",
 Inventário_de_Estoque:"15.Inventário de Estoque",
 Movimentação_Física_dos_Produtos:"16.Movimentação Física dos Produtos",
 Orçamento:"17.Orçamento",

 Pedido_de_Venda:"18.Pedido de Venda",
 Venda_de_Balcão:"19.Venda de Balcão - PDV - Frente de Loja",
 Compras:"20.Compras",
 Pesquisa_de_notas:"21. Pesquisa de notas emitidas contra o CNPJ (Aceitar ou desconhecer).",
 Baixa_automática_de_XML:"22. Baixa automática de XML, Leitura de XML de forma ágil (Manifesto, aceitar e desconhecer)",
 Emissão_de_NFCe:"23.Emissão de NFC-e / de NF-E 4.0 / CT-Os / MDF-e / CT-e/Nota Fiscal do Produtor",
 Sped_Fiscal:"24. Sped Fiscal / Sped Contribuições / Sintegra",

 Backup:"25.Backup",
 Relatórios:"26.Relatórios;",
 Ordem_de_Serviço:"27. Ordem de Serviço",
 Etiqueta:"28. Etiqueta Argox e Zebra",
 Busca:"29. Busca dados de empresa pelo CNPJ",
 Tela:"30. Tela de delivery",
 SAT:"31. SAT",
 //ProductFeature

  productFeature_title: "Compra Garantida com o Mercado Pago",
  productFeature_title_p1:"Receba o produto que está esperando ou devolvemos o seu dinheiro",

  Formas_de_pagamento:"Formas de pagamento",
  Formas_de_pagamento_p1:"Cartões de crédito, cartões de débito, boleto bancário",
  Comprar:"Comprar",

  

}
export default pt;
